module.exports = require('./helpers/bundle-url').getBundleURL('1OwBs') + "demo-light.74a5f79b.svg" + "?" + Date.now();